import React, { useLayoutEffect, useRef } from 'react';
import { CustomTileData } from 'features/layout/features/config/types';
import { CustomTileContent } from 'features/layout/tiles/CustomTileContent';
import { useCustomTileHostRegistry } from 'features/layout/tiles/custom-tile-host/registry';

type CustomTileProps = {
  data: CustomTileData;
};

// Inline because a class first rendered inside PiP has no rules there. zIndex undoes Tile's
// `& *: { zIndex: 1 }`, which a flex item honours while static and would raise above the host.
const SLOT_STYLE: React.CSSProperties = {
  width: '100%',
  height: '100%',
  zIndex: 'auto',
};

const CustomTileDisplay = React.memo(({ data }: CustomTileProps) => {
  const registry = useCustomTileHostRegistry();
  const slotRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (!registry || !slotRef.current) {
      return undefined;
    }

    return registry.registerSlot(data.name, slotRef.current);
  }, [registry, data.name]);

  // Both roots that render custom tiles mount a layer, so this is the kill switch and what tests
  // rendering the tile on its own fall back to.
  if (!registry) {
    return <CustomTileContent data={data} />;
  }

  return <div ref={slotRef} style={SLOT_STYLE} />;
});

export default CustomTileDisplay;
